import ServiceBase from './serviceBase';
import {
  EsgIndicatorDto,
  EsgIndicatorGridDto,
  OperationIndicatorContextDto,
} from './types/EsgIndicators';

class IndicatorsService extends ServiceBase {
  getIndicatorsByOperation = async (operationId: number): Promise<OperationIndicatorContextDto> =>
    this.get<OperationIndicatorContextDto>(`indicators/operation/${operationId}`);

  getIndicatorsStatusByOperation = async (
    operationId: number,
    queryDate: string
  ): Promise<EsgIndicatorGridDto[]> => {
    const queryParams = `&queryDate=${queryDate}`;

    return this.get<EsgIndicatorGridDto[]>(`indicators/${operationId}/status?${queryParams}`);
  };

  saveIndicators = async (operationId: number, indicators: EsgIndicatorDto[]): Promise<void> =>
    this.post<void>(`indicators/${operationId}/save`, indicators);

  sendIndicators = async (operationId: number, indicators: EsgIndicatorDto[]): Promise<void> =>
    this.post<void>(`indicators/${operationId}/send`, indicators);

  exportExcel = async (operationId: number): Promise<boolean> => {
    await this.download(`indicators/excel/${operationId}`);
    return true;
  };
}

const indicatorsService = new IndicatorsService();

export default indicatorsService;
